import { listCurrentClasses } from '$lib/api/classes';
import type { PageLoad } from './$types';

export const load: PageLoad = ({ fetch }) => {
  return {
    currentClassesPromise: listCurrentClasses(fetch),
    meta: {
      title: 'Classes',
      activeNav: 'classes',
      breadcrumbs: {
        activeTitle: 'Classes',
        items: [],
      },
    },
  };
};
